
@let type = node.type;
@if (type != 'WHILE' && type != 'IF' && type != 'FOREACH') {
     <ng-container [ngTemplateOutlet]="defaultTemplate"></ng-container>
} @else if ( type == 'WHILE' || type == 'FOREACH') {
     <ng-container [ngTemplateOutlet]="groupTemplate"></ng-container>
}

<ng-template #defaultTemplate>
      <div fNodeInput *ngFor="let input of node.inputs" [fInputId]="input" class="left" fOutputConnectableSide="right"
        [fInputMultiple]="node.multiple"></div>
    <div fNodeOutput *ngFor="let output of node.outputs" [fOutputId]="output"  fOutputConnectableSide="right" class="right"
        [fOutputMultiple]="node.multiple"></div>

    <nz-icon nzType="holder" fDragHandle class="wh-node-toggle-icon-drag" *ngIf="selectedVersion?.status=='DRAFT'"></nz-icon>

    <span class="material-symbols-outlined wh-node-toggle-icon-variable" nz-tooltip="{{'worflow.variable.node.tooltip'|translateTA}}" fDragHandle *ngIf="this.node.inputParameters?.length > 0">alternate_email</span>
    
    <label nz-checkbox class="debug" [(ngModel)]="node.debug" *ngIf="debug">{{'debug'|translateTA}}</label>

    @if(node.icon){
        <span class="material-symbols-outlined wh-node-icon" *ngIf="!node.svg">{{node.icon}}</span>
        <nz-icon class="wh-node-icon" *ngIf="node.svg" [nzType]="'custom:' + node.icon"></nz-icon>
    }

    @if(node.parentId){
        <nz-icon nzType="team" class="wh-node-icon-group" (dblclick)="killGroup($event,node)" [nz-tooltip]="'worflow.grouped'|translateTA:{parentId:node.parentId}"></nz-icon>
    }
        
    <div class="node-content">
        <div class="wh-node-title">
            {{node.componentName|translateTA}}
        </div>
    </div>

    <div class="wh-node-status" [style.backgroundColor]="color"></div>

    <nz-switch [(ngModel)]="node.active" [nzSize]="'small'" class="wh-node-activation"></nz-switch>

    @let log = getDebuggingLog();
    <div class="wh-node-log" *ngIf="debug && log!=null">
        <nz-icon nzType="check-circle" nzTheme="twotone" nzTwotoneColor="#52c41a" *ngIf="log?.error==false && log?.resultList.length>0" (click)="openResult(log)" />
        <nz-icon nzType="warning" nzTheme="twotone" nzTwotoneColor="#eb4034" *ngIf="log?.error==true"  (click)="openResult(log)"/>
    </div>
    
    <div class="wh-node-name" *ngIf="node.name!=null && node.name!=''">
        <span class="wh-node-name-text">{{node.name}}</span>
    </div>   
</ng-template>

<ng-template #groupTemplate>
   <webhook-edit-node-group [debug]="debug" [debugging]="debugging" [node]="node" [color]="color" [selectedVersion]="selectedVersion"></webhook-edit-node-group>
</ng-template>

